export const featureFlagNameList = {
    sweepr: "sweepr",
    replacementEsim: "replacement-esim",
} as const;
